import React, {FC} from 'react';

import {Box, DialogContent, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {LargeExpressIcon} from 'assets/icons/largeExpressIcon';

import {BasketDialogTitle} from './BasketDialogTitle';
import {StyledDialog, StyledBottomSheet} from './styles';

export interface ExpressDeliveryDetailsModalProps {
  open: boolean;
  onClose: () => void;
  isReactNativeWebView: boolean;
}

export const ExpressDeliveryDetailsModal: FC<ExpressDeliveryDetailsModalProps> = ({
  open,
  onClose,
  isReactNativeWebView
}) => {
  const {t} = useTranslation();
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;
  return (
    <ModalContainer className="MakroFleetDeliveryModal" open={open} onClose={onClose} anchor="bottom">
      <BasketDialogTitle title={t('sellerDelivery.makroFleet.deliveryHandledByMakro')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={1}>
          <LargeExpressIcon />
          <Box>
            <Typography fontSize={14} fontWeight={400}>
              {t('express.message.shopInExpressMode')}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={12} fontWeight={400} color="grey.400">
              {t('express.message.limitedExpressSlots')}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={12} fontWeight={400} color="grey.400">
              {t('express.message.slotsTimeFrame')}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

ExpressDeliveryDetailsModal.displayName = 'ExpressDeliveryDetailsModal';
